// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomReddit = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.8936 8.09709C15.8583 7.14133 15.0559 6.3951 14.0972 6.42759C13.6723 6.44235 13.2684 6.61639 12.9616 6.90828C11.6105 5.988 10.0235 5.48343 8.39233 5.44813L9.16227 1.74613L11.702 2.28021C11.7726 2.93213 12.3567 3.40421 13.0086 3.33326C13.6606 3.26266 14.1326 2.67853 14.0617 2.02661C13.9907 1.37469 13.4069 0.902608 12.755 0.97356C12.3802 1.01185 12.0441 1.23015 11.8585 1.5547L8.94994 0.97356C8.75236 0.929303 8.55461 1.05312 8.51035 1.25386C8.51035 1.25684 8.51035 1.25684 8.51035 1.25965L7.63433 5.37753C5.9824 5.40423 4.37491 5.91161 3.00626 6.83768C2.31008 6.18295 1.21278 6.21526 0.55805 6.91443C-0.09668 7.6106 -0.064365 8.70791 0.634798 9.36264C0.770556 9.48944 0.926687 9.59868 1.10073 9.67543C1.08879 9.84947 1.08879 10.0235 1.10073 10.1976C1.10073 12.8553 4.19805 15.0174 8.0179 15.0174C11.8377 15.0174 14.9351 12.8581 14.9351 10.1976C14.947 10.0235 14.947 9.84947 14.9351 9.67543C15.5308 9.37739 15.9056 8.76376 15.8936 8.09709ZM4.02682 9.28589C4.02682 8.63116 4.56089 8.09709 5.21562 8.09709C5.87035 8.09709 6.40443 8.63116 6.40443 9.28589C6.40443 9.94062 5.87035 10.4747 5.21562 10.4747C4.55791 10.4687 4.02682 9.9408 4.02682 9.28589ZM10.9205 12.5955V12.5483C10.0767 13.1825 9.04443 13.5069 7.98822 13.4628C6.93201 13.507 5.89986 13.1825 5.05598 12.5483C4.94393 12.4125 4.96448 12.2092 5.10024 12.0971C5.21808 11.9998 5.38633 11.9998 5.50734 12.0971C6.22125 12.6193 7.09148 12.8848 7.97627 12.8433C8.86125 12.8906 9.73446 12.6368 10.457 12.1208C10.5868 11.994 10.7991 11.9968 10.9261 12.1266C11.053 12.2564 11.0501 12.4687 10.9205 12.5955ZM10.7582 10.5602C10.7376 10.5602 10.7199 10.5602 10.6992 10.5602L10.7081 10.516C10.0534 10.516 9.51931 9.98189 9.51931 9.32716C9.51931 8.67243 10.0534 8.13836 10.7081 8.13836C11.3629 8.13836 11.8969 8.67243 11.8969 9.32716C11.9233 9.98207 11.4131 10.5335 10.7582 10.5602Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomReddit };
